import { FieldSettings, TextFilter } from '@progress/kendo-react-data-tools'
import { PaymentProviderFilterKey } from 'api/PaymentProvider/Types/PaymentProviderGroupDto'
import { GridFilterOperatorEnum, GridFilterOperatorNameEnum } from 'types/GridFilterOperatorEnum'

import { MultiSelectPaymentProviderFilter } from './common.filter'

export const getAllowedPaymentProviderFilterFields = (): FieldSettings[] => [
  {
    name: PaymentProviderFilterKey.name,
    label: 'PSP Group Name',
    filter: TextFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
      {
        text: GridFilterOperatorNameEnum.likeOperator,
        operator: GridFilterOperatorEnum.likeOperator,
      },
    ],
  },
  {
    name: PaymentProviderFilterKey.paymentProvider,
    label: 'Payment Provider',
    filter: MultiSelectPaymentProviderFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
]
